import {
  Checkbox,
  FormControlLabel,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";
import { ReactNode } from "react";

export interface AuturaCheckboxProps {
  checked: boolean;
  setChecked: (value: boolean) => void;
  label: string;
  disabled?: boolean;
  sx?: SxProps;
}

const AuturaCheckbox = ({
  checked,
  setChecked,
  label,
  disabled = false,
  sx,
}: AuturaCheckboxProps): ReactNode => {
  return (
    <Stack direction={"column"} spacing={0} sx={sx}>
      <FormControlLabel
        sx={{ flex: 1 }}
        control={
          <Checkbox
            checked={checked}
            disabled={disabled}
            onChange={(e) => setChecked(e.target.checked)}
          />
        }
        label={<Typography variant="subtitle1">{label}</Typography>}
      />
    </Stack>
  );
};

export default AuturaCheckbox;
